import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import type { ReactNode } from 'react';

import { tokens, Button, Tooltip } from '@hotjar/hotsauce';
import { useTippy } from '@hotjar/webapp/hooks/useTippy';

import { Dropdown, List, Item } from './Dropdown';

export interface ItemProps {
  title: string | ReactNode;
  subTitle: string | ReactNode;
  onClick: () => void;
}

export interface RetakeDropdownProps {
  onRetake: () => void;
  onTakeNew: () => void;
}

export const RetakeDropdown = ({
  onRetake,
  onTakeNew,
}: RetakeDropdownProps): JSX.Element | null => {
  const { t } = useTranslation();
  const tippyInstance = useTippy();

  const handleRetake = (): void => {
    onRetake();
    tippyInstance.close();
  };

  const handleTakeNew = (): void => {
    onTakeNew();
    tippyInstance.close();
  };

  return (
    <Dropdown
      placement="bottom-start"
      onCreate={tippyInstance.set}
      trigger={
        <Tooltip text={t('heatmaps:statusbar.retaker.tooltip')}>
          <Button
            kind="ghost"
            size="s"
            css={css`
              margin-left: ${tokens.spacer.x0pt5};
            `}
            data-testid="screenshot-update-button"
          >
            {t('heatmaps:statusbar.retaker.label')}
          </Button>
        </Tooltip>
      }
    >
      <List>
        <Item
          title={t('heatmaps:statusbar.retaker.item-refresh-title')}
          subTitle={t('heatmaps:statusbar.retaker.item-refresh-subTitle')}
          onClick={handleRetake}
        />
        <Item
          title={t('heatmaps:statusbar.retaker.item-take-new-title')}
          subTitle={t('heatmaps:statusbar.retaker.item-take-new-subTitle')}
          onClick={handleTakeNew}
        />
      </List>
    </Dropdown>
  );
};
